import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import PaymentSuccess from "./pages/PaymentSuccess";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DayView from "./pages/DayView";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pago-exitoso" element={<PaymentSuccess />} />
            <Route path="/acceder" element={<Login />} />
            <Route path="/programa" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/programa/dia/:day" element={<ProtectedRoute><DayView /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
